import { Platform } from "react-native";
import { io } from "socket.io-client";

/**
 * Web:
 * ใช้โดเมนเดียวกับหน้าเว็บ
 * เช่น https://หน้าเว็บของคุณ/socket.io/
 * แล้ว Nginx Rewrite เดิมจะส่งต่อไป API
 *
 * Android/iOS:
 * เชื่อม Public API โดยตรง
 */
const SOCKET_URL =
  Platform.OS === "web"
    ? undefined
    : "https://spl-api.veninecopper.com";

export const socket = io(SOCKET_URL, {
  path: "/socket.io",

  /**
   * หน้า order_scales.tsx เป็นผู้เรียก socket.connect()
   */
  autoConnect: false,

  /**
   * ให้เริ่มด้วย Polling แล้วค่อย Upgrade เป็น WebSocket
   * ไม่บังคับ WebSocket อย่างเดียว
   */
  transports: ["polling", "websocket"],

  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  timeout: 15000,

  withCredentials: false,
});

socket.on("connect", () => {
  console.log("Socket connected:", socket.id);
  console.log(
    "Socket transport:",
    socket.io.engine.transport.name,
  );
});

socket.io.on("reconnect_attempt", (attempt) => {
  console.log(
    "Socket reconnect attempt:",
    attempt,
  );
});

socket.on("connect_error", (error) => {
  console.error("Socket connect error:", {
    message: error.message,
    description: (error as any)?.description,
    context: (error as any)?.context,
    platform: Platform.OS,
    socketUrl:
      SOCKET_URL ?? "same-origin ผ่าน Nginx",
  });
});

socket.on("disconnect", (reason) => {
  console.log("Socket disconnected:", reason);
});

export default socket;